import apiCall from '../../index'

const apiService = '/api-erpunigas/api/v1/portal/directorio'
const authorization = 'Authorization'
const tipoToken = 'Bearer'

const service = {
  findAll(params) {
    const query = `?esPublico=${params.esPublico}&tipo=${params.tipo}&limit=${params.limit}&page=${params.page}&query=${params.query}&sortBy=${params.sortBy}`
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${tipoToken} ${localStorage.getItem('accessToken')}`
      apiCall
        .get(apiService + query)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  create(model) {
    const formData = new FormData()
    formData.append('nombres', model.nombres)
    formData.append('apellidos', model.apellidos)
    formData.append('cargo', model.cargo)
    formData.append('email', model.email)
    formData.append('celular', model.celular)
    formData.append('orden', model.orden)
    formData.append('esPublico', model.esPublico)
    if (model.foto !== null) formData.append('foto', model.foto)
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${tipoToken} ${localStorage.getItem('accessToken')}`
      apiCall
        .post(apiService, formData)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  update(model) {
    const formData = new FormData()
    formData.append('idDirectorio', model.idDirectorio)
    formData.append('nombres', model.nombres)
    formData.append('apellidos', model.apellidos)
    formData.append('cargo', model.cargo)
    formData.append('email', model.email)
    formData.append('celular', model.celular)
    formData.append('orden', model.orden)
    formData.append('esPublico', model.esPublico)
    if (model.foto !== null) formData.append('foto', model.foto)
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${tipoToken} ${localStorage.getItem('accessToken')}`
      apiCall
        .put(apiService, formData)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  updateQR(model) {
    const formData = new FormData()
    formData.append('idDirectorio', model.idDirectorio)
    if (model.qr !== null) formData.append('qr', model.qr)
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${tipoToken} ${localStorage.getItem('accessToken')}`
      apiCall
        .put(apiService, formData)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  delete(params) {
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${tipoToken} ${localStorage.getItem('accessToken')}`
      apiCall
        .delete(`${apiService}/${params.id}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
}

export default service
